import as1 from "../../../assets/images/AS1.jpg";
import as10 from "../../../assets/images/AS10.jpg";
import as11 from "../../../assets/images/AS11.jpg";
import as12 from "../../../assets/images/AS12.jpg";
import as13 from "../../../assets/images/AS13.jpg";
import as14 from "../../../assets/images/AS14.jpg";
import as15 from "../../../assets/images/AS15.jpg";
import as16 from "../../../assets/images/AS16.jpg";
import as2 from "../../../assets/images/AS2.jpg";
import as3 from "../../../assets/images/AS3.jpg";
import as5 from "../../../assets/images/AS5.jpg";
import as6 from "../../../assets/images/AS6.jpg";
import as7 from "../../../assets/images/AS7.jpg";
import as8 from "../../../assets/images/AS8.jpg";
import as9 from "../../../assets/images/AS9.jpg";
import img1 from "../../../assets/images/applied1.jpg";
import img2 from "../../../assets/images/applied2.jpg";
import img3 from "../../../assets/images/applied3.jpg";
import img4 from "../../../assets/images/applied4.jpg";
import img5 from "../../../assets/images/applied5.jpg";
import img6 from "../../../assets/images/applied6.jpg";
import img7 from "../../../assets/images/applied7.jpg";
import img17 from "../../../assets/images/AS_2026/collage.jpg";
import img18 from "../../../assets/images/AS_2026/GROUP PIC.jpg";
import img19 from "../../../assets/images/AS_2026/Image 2.jpg";
import img20 from "../../../assets/images/AS_2026/Image 3.jpg";
import img21 from "../../../assets/images/AS_2026/Image 4.jpg";
import img22 from "../../../assets/images/AS_2026/Image 5.jpg";
import img23 from "../../../assets/images/AS_2026/Image 6.jpg";
import img24 from "../../../assets/images/AS_2026/Image 7.jpg";
import img25 from "../../../assets/images/AS_2026/Image-1.jpg";
import img26 from "../../../assets/images/AS_2026/Image-2 2.jpg";
import img27 from "../../../assets/images/AS_2026/Image-2 3.jpg";
import img28 from "../../../assets/images/AS_2026/Image-2 4.jpg";
import img29 from "../../../assets/images/AS_2026/Image-2 5.jpg";
import img30 from "../../../assets/images/AS_2026/Image-2.jpeg";
import img31 from "../../../assets/images/AS_2026/Image-2.jpg";
import img32 from "../../../assets/images/AS_2026/Image-3 2.jpg";
import img33 from "../../../assets/images/AS_2026/Image-3 3.jpg";
import img34 from "../../../assets/images/AS_2026/Image-3.jpg";
import img35 from "../../../assets/images/AS_2026/Image-4.jpg";
import img36 from "../../../assets/images/AS_2026/Image-II.jpg";
import img37 from "../../../assets/images/AS_2026/Image.jpeg";
import img38 from "../../../assets/images/AS_2026/Image.jpg";
import img39 from "../../../assets/images/AS_2026/IMG-2.jpg";
import img40 from "../../../assets/images/AS_2026/Img-3.jpg";
import img41 from "../../../assets/images/AS_2026/Img.jpg";
import img42 from "../../../assets/images/AS_2026/Photo from__ (1).jpg";
import img43 from "../../../assets/images/AS_2026/Photo from__.jpg";

export const Activities = [
  { id: 1, Avatar: img1 },
  { id: 3, Avatar: img3 },
  { id: 4, Avatar: img4 },
  { id: 5, Avatar: img5 },
  { id: 6, Avatar: img6 },
  { id: 2, Avatar: img2 },
  { id: 7, Avatar: img7 },
  { id: 8, Avatar: as1 },
  { id: 9, Avatar: as2 },
  { id: 10, Avatar: as3 },
  { id: 12, Avatar: as5 },
  { id: 13, Avatar: as6 },
  { id: 14, Avatar: as7 },
  { id: 15, Avatar: as8 },
  { id: 16, Avatar: as9 },
  { id: 17, Avatar: as10 },
  { id: 18, Avatar: as11 },
  { id: 19, Avatar: as12 },
  { id: 20, Avatar: as13 },
  { id: 21, Avatar: as14 },
  { id: 22, Avatar: as15 },
  { id: 23, Avatar: as16 },
  { id: 24, Avatar: img17 },
  { id: 25, Avatar: img18 },
  { id: 26, Avatar: img19 },
  { id: 27, Avatar: img20 },
  { id: 28, Avatar: img21 },
  { id: 29, Avatar: img22 },
  { id: 30, Avatar: img23 },
  { id: 31, Avatar: img24 },
  { id: 32, Avatar: img25 },
  { id: 33, Avatar: img26 },
  { id: 34, Avatar: img27 },
  { id: 35, Avatar: img28 },
  { id: 36, Avatar: img29 },
  { id: 37, Avatar: img30 },
  { id: 38, Avatar: img31 },
  { id: 39, Avatar: img32 },
  { id: 40, Avatar: img33 },
  { id: 41, Avatar: img34 },
  { id: 42, Avatar: img35 },
  { id: 43, Avatar: img36 },
  { id: 44, Avatar: img37 },
  { id: 45, Avatar: img38 },
  { id: 46, Avatar: img39 },
  { id: 47, Avatar: img40 },
  { id: 48, Avatar: img41 },
  { id: 49, Avatar: img42 },
  { id: 50, Avatar: img43 },
];
